import type React from "react";

import { List, ListItem, ListItemButton } from "@mui/material";
import styled, { useTheme } from "styled-components";

export type Option = {
  value: string;
  title: string;
};

interface Props {
  title: string;
  options: Option[];
  selectedOption?: Option;
  onChange: (option?: Option) => void;
}

export const FilterSection: React.FC<Props> = ({ title, options, selectedOption, onChange }) => {
  const theme = useTheme();

  return (
    <>
      <FilterSectionHeader>{title}</FilterSectionHeader>
      <List sx={{ width: "100%", mb: 2 }}>
        {options.map(option => (
          <ListItem key={option.value} disableGutters disablePadding>
            <ListItemButton
              onClick={() => onChange(option.value !== selectedOption?.value ? option : undefined)}
              sx={{
                bgcolor: option.value === selectedOption?.value ? `${theme.colors.redesign.db20} !important` : "white",
              }}
            >
              {option.title}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </>
  );
};

const FilterSectionHeader = styled.div`
  font-size: 16px;
  font-weight: 500;
`;
